import JDialog from '@atoms/JDialog';
import React, { createContext, useState, useMemo } from 'react';

interface JDialogData {
  open: boolean;
  title: string;
  body: React.ReactNode;
  type: dialogTypes;
}
export type dialogTypes = 'basic' | 'filter';
interface JDialogContextProps {
  showJDialog: (
    title: string,
    body: React.ReactNode,
    type?: dialogTypes,
  ) => void;
  closeJDialog: () => void;
}

export const JDialogContext = createContext<JDialogContextProps | undefined>(
  undefined,
);

export const JDialogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [JDialogData, setJDialogData] = useState<JDialogData | null>(null);

  const showJDialog = (
    title: string,
    body: React.ReactNode,
    type: dialogTypes = 'basic',
  ) => {
    setJDialogData({ open: true, title, body, type });
  };

  const closeJDialog = () => {
    setJDialogData(null);
  };
  const contextValue = useMemo(() => {
    return { showJDialog, closeJDialog };
  }, [showJDialog, closeJDialog]);

  return (
    <JDialogContext.Provider value={contextValue}>
      {children}
      {JDialogData && (
        <JDialog
          type={JDialogData.type}
          title={JDialogData.title}
          open={JDialogData.open}
          onClose={closeJDialog}
        >
          {JDialogData.body}
        </JDialog>
      )}
    </JDialogContext.Provider>
  );
};
